import React from 'react';
import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import type {
  IComponentPreviewWrapper,
  PreviewWrapperProps,
} from '@wix/editor-elements-types/thunderboltPreview';
import type {
  TextOnPathProps,
  TextOnPathPreviewWrapperProps,
} from '../TextOnPath.types';

function withComponentPreview(
  WrappedComponent: React.ComponentType<TextOnPathProps>,
): IComponentPreviewWrapper<TextOnPathProps, TextOnPathPreviewWrapperProps> {
  return ({
    previewWrapperProps = {},
    ...viewerProps
  }: PreviewWrapperProps<TextOnPathProps, TextOnPathPreviewWrapperProps>) => {
    const { font: textFont, text } = previewWrapperProps;
    // doesn't work, returns same key
    // const previousTextFont = usePrevious(textFont);
    // const key = useResetComponent({
    //   shouldResetComponent: previousTextFont !== textFont,
    //   id: viewerProps.id,
    // });

    return <WrappedComponent {...viewerProps} key={textFont + text} />;
  };
}

export default (ViewerComponent: React.ComponentType<TextOnPathProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent));
